import { useMapped } from "@omni/utils/context/mapped.context";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

import {
    useCategoryContext,
    useSubCategory
} from "@/components/Navigation/FlyoutMenu/components/category/context/category.context";
import { useFlyoutMenuContext } from "@/components/Navigation/FlyoutMenu/context/flyoutMenu.context";

type LinkContextValue = {
    active: boolean;
};

type LinkContextProviderProps = {
    children: ReactNode;
};

export const LinkContext = createContext<LinkContextValue | undefined>(
    undefined
);

export const LinkContextProvider = ({ children }: LinkContextProviderProps) => {
    const { activeCategoryIndexes } = useFlyoutMenuContext();
    const { index: categoryIndex } = useCategoryContext();
    const { index: subCategoryIndex } = useMapped();
    const { category } = useSubCategory(subCategoryIndex);

    if (!category) return null;

    const active = activeCategoryIndexes[categoryIndex] === subCategoryIndex;

    return (
        <LinkContext
            value={{
                active: active
            }}
        >
            {children}
        </LinkContext>
    );
};

export const useLinkContext = () => {
    const context = use<LinkContextValue | undefined>(LinkContext);

    if (!isDefined(context)) {
        throw new Error(`${LinkContext.displayName} is undefined.`);
    }

    return context;
};
